// removed by extract-text-webpack-plugin
module.exports = {"accept":"tos__accept-vCxjn blocks__huge-2XOet blocks__blue-tjpdI blocks__button-1iODk","cancel":"tos__cancel-2JyaT blocks__huge-2XOet blocks__grey-2yo9d blocks__button-1iODk","modal":"tos__modal-1Tfw_","container":"tos__container-pwIcr","animatetop":"tos__animatetop-3ATHq","modal-content":"tos__modal-content-ar-v9","top-scroll-area":"tos__top-scroll-area-xpBwu","actions":"tos__actions-1fnBS","header":"tos__header-2McbW","section-header":"tos__section-header-2vp5y","section":"tos__section-3Tus0","link":"tos__link-1w8io","scrollDisabled":"tos__scrollDisabled-3yDbc"};


//////////////////
// WEBPACK FOOTER
// ./components/auth/tos/tos.css
// module id = 795
// module chunks = 0